module.exports = __webpack_public_path__ + "static/australia-map-dba8e4ceb370c2137830b5cec2d9bd0d.png";